import * as React from 'react';
import classNames from 'classnames';
const Cell = ({ itemPrefixCls, component, span, className, style, bordered, label, content, colon, }) => {
    const Component = component;
    if (bordered) {
        return (<Component className={classNames({
            [`${itemPrefixCls}-item-label`]: label,
            [`${itemPrefixCls}-item-content`]: content,
        }, className)} style={style} colSpan={span}>
        {label || content}
      </Component>);
    }
    return (<Component className={classNames(`${itemPrefixCls}-item`, className)} style={style} colSpan={span}>
      {label && (<span className={classNames(`${itemPrefixCls}-item-label`, {
        [`${itemPrefixCls}-item-colon`]: colon,
    })}>
          {label}
        </span>)}
      {content && <span className={classNames(`${itemPrefixCls}-item-content`)}>{content}</span>}
    </Component>);
};
export default Cell;
